import { render } from "./Item.vue?vue&type=template&id=084a4c52&scoped=true"
import script from "./Item.vue?vue&type=script&lang=js"
export * from "./Item.vue?vue&type=script&lang=js"

import "./Item.vue?vue&type=style&index=0&id=084a4c52&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-084a4c52"

export default script